import React from 'react';

const ExecutiveSummary = () => {
  return (
    <div>
       <h2 className="text-4xl font-bold text-black mb-5">
  Executive<span className="text-[#680099] ml-2 font-bold">Summary</span>
</h2>

      <p style ={{ fontSize: '20px'}}>Vigovia Travel Technologies Pvt Ltd is revolutionizing the B2C travel sector with an innovative platform offering
         customizable travel solutions, live pricing, and forex integration(pending FFMC license approval).</p>
      <p style ={{ fontSize: '20px'}}> 
        With ₹1 crore in organic revenue generated within its first year, 
         Vigovia is now positioned to expand aggresively in the B2B space while launching a B2C channel in India and UAE.
         This funding will acclerate platform scalability, market reach, and operational efficiency.
      </p>
      <br></br>

      <h5 className="text-xl font-bold text-black mb-3"> Investment Proposal</h5>

      <li style={{fontSize: '19px'}}> <strong> Funding Required</strong>: ₹1.5 - 2 crore</li>
      <li style={{fontSize: '19px'}}> <strong> Equity Offered</strong>: Revealing soon!</li>
      <li style={{fontSize: '19px'}}> <strong> Value on</strong>: Revealing soon!</li>

      <br />
      <h5 className="text-xl font-bold text-black mb-3"> Investment Purpose</h5>
      <p style={{fontSize: '19px'}}> To support Vigovia's B2B and B2C platform expansion, agent and customer acquisition, forex service launch, and targeted marketing.</p>



      
    </div>
  );
};

export default ExecutiveSummary;
